import ApiService from '@/services/CommonApiService.js'
import moment from 'moment'

export const namespaced = true
export const state = {
  pods: [],
  selectedPod: '',
  selectedDateQuickAction: 'last30',
  selectedDate: [
    moment()
      .subtract(30, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss'),
    moment().format('YYYY-MM-DD HH:mm:ss')
  ],
  selectedUtcOffset: 'Australia/Sydney',
  selectedProductId: '',
  padCycleLookUp: {
    date: moment().format('YYYY-MM-DD 00:00:00'),
    bounds: 1,
    utcOffset: null,
    condition: 1
  }
}

export const mutations = {
  SET_PODS(state, value) {
    state.pods = value
  },
  SET_SELECTED_POD(state, value) {
    state.selectedPod = value
  },
  SET_SELECTED_DATE_QUICK_ACTION(state, value) {
    state.selectedDateQuickAction = value
  },
  SET_SELECTED_DATE(state, value) {
    state.selectedDate = value
  },
  SET_SELECTED_UTC_OFFSET(state, value) {
    state.selectedUtcOffset = value
  },
  SET_SELECTED_PRODUCT_ID(state, value) {
    state.selectedProductId = value
  },
  SET_PAD_CYCLE_LOOKUP(state, value) {
    state.padCycleLookUp = value
  }
}

export const actions = {
  fetchPods({ commit }) {
    return ApiService.GetConfiguration()
      .then(response => {
        commit('SET_PODS', response.data.pods)
        if (!this.state.pods.selectedPod && response.data.pods.length) {
          commit('SET_SELECTED_POD', response.data.pods[0])
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}
